/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ExcludedCompanyResponse {
  id: string;
  company_name: string;
  company_domain?: string | null;
  added_by?: string | null;
  created_at: string;
}
